import { combineReducers } from '@reduxjs/toolkit';
import { incApi } from 'api/inc-api';
import { persistReducer } from 'redux-persist';
import storage from '../util/client-local-forage';
import appReducer from './app/app.reducer';
import user from './user/user.slice';
import i18n from './i18n/i18n.slice';

const appPersistConfig = {
  key: 'app',
  storage,
  whitelist: ['theme', 'merchant', 'program', 'sidebar'],
};

const userPersistConfig = {
  key: user.name,
  storage,
  blacklist: ['userDetails'],
};

/* istanbul ignore next */
if (window.Cypress || process.env.NODE_ENV === 'test') {
  const timeout = window?.Cypress?.env('RP_TIMEOUT') ?? 100;
  appPersistConfig.timeout = timeout;
  userPersistConfig.timeout = timeout;
}

const mainReducer = combineReducers({
  [incApi.reducerPath]: incApi.reducer,
  app: persistReducer(appPersistConfig, appReducer),
  [user.name]: persistReducer(userPersistConfig, user.reducer),
  [i18n.name]: i18n.reducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'persist/PURGE') {
    return mainReducer(undefined, action);
  }

  return mainReducer(state, action);
};

export default rootReducer;
